import request from '../../axios/interceptor';
import API from '../../constant.api';

export interface SignUpPayload {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phoneNumber: string;
  password: string;
  termsAccepted: boolean;
  organizationName: string;
  organizationCode: string;
  organizationLogo?: string;
}

export interface OtpSentResponse {
  message: string;
  email: string; // masked
  expiresInSeconds: number;
  resendAfterSeconds: number;
}

const headers = { 'Content-Type': 'application/json' };

// All three endpoints are public: they use the shared axios instance directly so no Authorization header is attached.

// Step 1: validates the form and emails a 6-digit OTP
export const signUp = async (
  payload: SignUpPayload
): Promise<OtpSentResponse> => {
  const { data } = await request.post(API.USER_SIGNUP, payload, { headers });
  return data;
};

export const checkOrganizationCodeAvailable = async (
  code: string
): Promise<{ available: boolean }> => {
  const { data } = await request.get(API.USER_SIGNUP_ORG_CODE_AVAILABILITY, {
    params: { code },
    headers,
  });
  return data;
};

// Step 2: verifies the OTP; the account is created on success (201, no token)
export const verifySignUpOtp = async (payload: {
  email: string;
  otp: string;
}) => {
  const { data } = await request.post(API.USER_SIGNUP_VERIFY_OTP, payload, {
    headers,
  });
  return data;
};

export const resendSignUpOtp = async (payload: {
  email: string;
}): Promise<OtpSentResponse> => {
  const { data } = await request.post(API.USER_SIGNUP_RESEND_OTP, payload, {
    headers,
  });
  return data;
};
